import classnames from 'classnames';
import ChevronIcon from 'components/icons/ChevronIcon';
import React from 'react';
import CrossIcon from '~/reusable-components/icons/fullcolor/CrossIcon';

const CSS = require('./ModalHeader.module.scss');

interface ModalHeaderProps {
  title?: any;
  onClose?: () => void;
  onReset?: () => void;
  onBack?: () => void;
  isPageHeader?: boolean;
  variant?: 'white' | 'sandstone' | 'success';
}

function ModalHeader({
  title,
  onClose,
  onReset,
  onBack,
  isPageHeader,
  variant = 'sandstone',
}: ModalHeaderProps) {
  const classes = classnames(CSS.ModalHeader, {
    [CSS.ModalPageHeader]: isPageHeader,
  });
  return (
    <header className={classes} data-variant={variant}>
      {onReset && (
        <button onClick={onReset} className={CSS.ResetButton} data-area="reset">
          Reset
        </button>
      )}
      {onBack && (
        <button onClick={onBack} className={CSS.Button} data-area="back">
          <ChevronIcon
            height={12}
            width={12}
            className={CSS.ButtonIcon}
            direction="left"
          />
        </button>
      )}
      <div className={CSS.Title}>{title}</div>
      {onClose && (
        <button onClick={onClose} className={CSS.Button} data-area="close">
          <CrossIcon height={12} width={12} className={CSS.ButtonIcon} />
        </button>
      )}
    </header>
  );
}

export default ModalHeader;
